import React, { use, useEffect, useRef, useState } from "react";
import Row from "../layout/Row";
import SRPrimaryButton from "../buttons/SRPrimaryButton";
import SRSIconButton from "../buttons/SRSIconButton";
import IconButton from "../buttons/IconButton";
import { logoutUser } from "../auth/FirebaseAuth";
import { useAuth } from "../auth/FirebaseAuth";
import { useNavigate } from "react-router-dom";
import { getUserById } from "../models/UserFunctions";
import { getOrgById, getOrgByRef } from "../models/OrgFunctions";
import SupportAM from "../actionmenus/SupportAM";
import {
  getDocDataByRef,
  getFlutterTime,
  listenCollection,
  listenDocDataByIdX,
  queryCollection,
} from "../models/DataFunctions";
import OnlineStatus from "../config/OnlineStatus";
import Modal1 from "../modals/Modal1";
import { Rate, Spin } from "antd";
import TFGPT1 from "../textfields/TFGPT1";
import MLTF1 from "../textfields/MLTF1";
import PrimaryButton from "../buttons/PrimaryButton";
import sendRequest from "../api/send/sendRequest";
import { useAppContext } from "../config/AppContext";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { useSnackbar } from "notistack";
import { set } from "date-fns";
import createDocApi from "../api/database/createDocApi";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import Tippy from "@tippyjs/react";
import Icon1 from "../icons/Icon";
import SuperModal from "../modals/SuperModal";
import Spinner from "../loading/Spinner";
import { isLight } from "./VisibilityHelpers";
import SmallSpinner from "../loading/SmallSpinner";

function HeaderBar({
  navigateWorkspace,
  override_id,
  userData,
  orgData,
  maintenance_chill,
  maintenance_status,
}) {
  const { currentUser, loading } = useAuth();
  const [error, setError] = useState(null);

  const [fullScreen, setFullScreen] = useState(false);
  const [bugs_open, setBugsOpen] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (message, variant) => {
    enqueueSnackbar(message, { variant });
  };
  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [supportOpen, setSupportOpen] = useState(false);
  const [online_members, setOnlineMembers] = useState([]);
  const unsubscribeMembers = useRef(null);
  const [websocketActive, setWebsocketActive] = useState(false);

  const [maintenance, setMaintenance] = useState(false);

  const handleSetMaintenance = async (value) => {
    setMaintenance(value);
    if (userData && value?.active && !userData.maintenance_proof) {
      await logoutUser();
      setTimeout(() => {
        console.warn("maintenance active, redirecting to entree");

        navigateWorkspace("/entree");
      }, 1000);
    }
  };
  const handleSetMembers = async (value) => {
    setOnlineMembers(value);
  };
  const handleSetWebsocketActive = async (value) => {
    setWebsocketActive(value.websocket_active);
  };
  const websocketActiveRef = useRef(null);

  const unsubscribeMaintenanceCaution = useRef(null);

  useEffect(() => {
    listenDocDataByIdX(
      "maintenance",
      "maintenance",
      handleSetMaintenance,
      unsubscribeMaintenanceCaution
    );

    return () => {
      if (unsubscribeMaintenanceCaution?.current) {
        unsubscribeMaintenanceCaution.current();
      }
    };
  }, []);

  useEffect(() => {
    if (!userData) {
      return;
    }
    let filters = [
      {
        field: "org_id",
        operator: "==",
        value: userData.org_id,
      },
    ];

    listenDocDataByIdX(
      "maintenance",
      "main",
      handleSetWebsocketActive,
      websocketActiveRef
    );
    if (!websocketActive) {
      return;
    }

    listenCollection(
      "user",
      filters,
      100,
      null,
      null,

      handleSetMembers,
      unsubscribeMembers
    );

    return () => {
      if (unsubscribeMembers?.current) {
        unsubscribeMembers.current();
      }
      if (websocketActiveRef?.current) {
        websocketActiveRef.current();
      }
    };
  }, [userData]);

  const handleFetchData = async () => {
    if (userData) {
      if (userData) {
        let filters = [
          {
            field: "org_id",
            operator: "==",
            value: userData.org_id,
          },
        ];
        let members = await queryCollection("user", filters);

        if (!isLight(orgData)) {
          if (
            !["starter", "business", "premium"].includes(
              orgData.facturation?.plan
            )
          ) {
            let trial_days_left = Math.floor(
              (new Date(
                orgData.creation_date?.seconds +
                  (orgData.facturation.trial_period || 30) * 24 * 3600
              ) -
                getFlutterTime().seconds) /
                60 /
                60 /
                24
            ).toFixed(0);

            if (trial_days_left <= 0) {
              await updateDocDataFieldApi(
                orgData.ref,
                "facturation.in_trial",
                false,
                prefix
              );
              if (!isLight(orgData)) {
              } else {
                await updateDocDataFieldApi(
                  orgData.ref,
                  "facturation.restricted",
                  false,
                  prefix
                );
              }

              orgData = await getOrgById(userData.org_id);
            }
            if (trial_days_left > 0) {
              await updateDocDataFieldApi(
                orgData.ref,
                "facturation.in_trial",
                true,
                prefix
              );
              orgData = await getOrgById(userData.org_id);
            }
          } else {
            if (orgData.facturation?.in_trial) {
              await updateDocDataFieldApi(
                orgData.ref,
                "facturation.in_trial",
                false,
                prefix
              );
            }
          }
        }

        setOnlineMembers(members);
      }
    }
  };

  useEffect(() => {
    if (userData && orgData) {
      handleFetchData(); // Fetch user data when currentUser is available
    }
  }, [userData, orgData]);

  const handleRefuseFeedback = async () => {
    let new_feedback = {
      ask: false,
      grade: "refused",
    };
    await updateDocDataFieldApi(
      userData.ref,
      "tracking.feedback",
      new_feedback,
      prefix
    );
    setNotationOpen(false);
    handleFetchData();
  };

  const [notationOpen, setNotationOpen] = useState(false);
  const [grade, setGrade] = useState(null);
  const [value, setValue] = useState("");

  if (
    loading ||
    !currentUser ||
    !userData ||
    !orgData ||
    !online_members ||
    !maintenance_status ||
    !maintenance_chill
  ) {
    return (
      <div>
        <SmallSpinner></SmallSpinner>
      </div>
    );
  }

  return (
    <div className=" w-full flex-row-reverse flex pointer-events-auto">
      <Modal1
        isOpen={userData?.tracking?.feedback?.ask}
        onClose={() => setNotationOpen(false)}
      >
        <div className="relative rounded-xl  flex flex-col gap-4 justify-center items-center w-c700">
          <div className="absolute -z-10  top-0 right-0 h-full w-full  rounded-xl">
            <img
              src="https://products.ls.graphics/mesh-gradients/images/87.-Spacy.jpg"
              className="w-full h-full rounded-xl"
            />
          </div>
          <div className="flex flex-col  rounded-xl w-full p-6 items-center bg-gradient-to-r from-wshadow_75 to-wshadow_10 ">
            {!grade && (
              <>
                <div className=" flex flex-row justify-between h-fit w-full gap-10  rounded-xl">
                  {" "}
                  <div className="text-hx1 mb-10">
                    Quelle est la probabilité que vous recommandiez{" "}
                    <span className="font-bold">hexagone</span> à d'autres
                    professionnels du bâtiment ?
                  </div>{" "}
                  <div
                    onClick={handleRefuseFeedback}
                    className="cursor-pointer rounded-full h-fit min-w-fit
                bg-shadow_5 px-4 py-2 text-black text-h3"
                  >
                    Plus tard
                  </div>
                </div>

                <div className="flex flex-row gap-1">
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((item) => (
                    <div
                      key={item}
                      className={`${grade === item ? "bg-black text-white " : "bg-white  hover:bg-black hover:text-white"} cursor-pointer rounded-md  duration-300 transition-all w-10 h-10 flex flex-row  border-1 shadow-md border-shadow_10  text-h1 items-center justify-center p-2`}
                      onClick={() => setGrade(item)}
                    >
                      {item}{" "}
                    </div>
                  ))}
                </div>
                <div className="flex flex-row gap-1 text-h3 text-neutral-400 font-medium justify-between  mt-3 w-c500">
                  <div>Très peu probable</div>
                  <div>Très probable</div>
                </div>
              </>
            )}
            {grade && (
              <>
                <div className="flex flex-row justify-between w-full gap-10 mb-6">
                  <div className="text-hx2 ">
                    Pourquoi avez-vous donné cette note ?
                  </div>{" "}
                  <div className="flex flex-row justify-end gap-2">
                    <div
                      onClick={() => setGrade(null)}
                      className="cursor-pointer rounded-full h-fit min-w-fit
                bg-shadow_5 px-4 py-2 text-black text-h3"
                    >
                      Retour
                    </div>
                    <div
                      onClick={() => setNotationOpen(false)}
                      className="cursor-pointer rounded-full h-fit min-w-fit
                bg-shadow_5 px-4 py-2 text-black text-h3"
                    >
                      Plus tard
                    </div>
                  </div>
                </div>

                <div className="flex flex-col gap-4 ">
                  <MLTF1
                    sx={{ width: "650px" }}
                    rows={2}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                  ></MLTF1>
                  <div className="flex flex-row justify-end w-full ">
                    <PrimaryButton className="w-fit" onClick={() => {}}>
                      Envoyer
                    </PrimaryButton>
                  </div>
                </div>
              </>
            )}{" "}
          </div>
        </div>
      </Modal1>
      <div className=" px-1 py-1  bg-white rounded-bl-xl">
        <div className="flex flex-row gap-2 items-center h-fit">
          {orgData.facturation?.test_account && (
            <div className="text-h3 items-center px-2 py-0.5 rounded-md bg-orange-400  text-white ">
              TEST
            </div>
          )}
          {!isLight(orgData) && orgData.facturation?.restricted && (
            <div
              onClick={() => navigateWorkspace("/facturation?upgrade=true")}
              className="text-h3 cursor-pointer px-2 py-0.5 rounded-full bg-red-500 text-center text-white"
            >
              Votre compte est restreint : Mettez à jour votre abonnement
            </div>
          )}
          {!isLight(orgData) && orgData.facturation?.in_trial && (
            <div
              onClick={() => navigateWorkspace("/facturation?upgrade=true")}
              className="flex flex-row gap-2 "
            >
              <div className="text-h3  px-2 py-0.5 rounded-full bg-red-100 text-center text-red-600">
                {
                  // get x trial days left from Date and orgData.creation_date
                  Math.floor(
                    (new Date(
                      orgData.creation_date.seconds +
                        (orgData.facturation.trial_period || 30) * 24 * 3600
                    ) -
                      getFlutterTime().seconds) /
                      60 /
                      60 /
                      24
                  ).toFixed(0)
                }{" "}
                jours restants
              </div>{" "}
              <div className="text-h3  px-3 py-0.5 cursor-pointer rounded-full hover:border-1 hover:border-green-400 bg-white shadow-md text-center text-black hover:text-green-400 hover:shadow-xl hover:text-h2 transition-all duration-300">
                Mettre à niveau
              </div>{" "}
            </div>
          )}
          {maintenance_chill?.ison && (
            <div className="text-h3 px-2 text-center text-shadow_50">
              {maintenance_chill?.message}
            </div>
          )}
          <div className="flex flex-row gap-1 items-center w-fit">
            {online_members
              .sort(
                (member1, member2) =>
                  member1.tracking?.isonline - member2.tracking?.isonline
              )
              .map((member) => (
                <div key={member.id} className="flex flex-row  items-center">
                  <Tippy
                    content={member.display_name}
                    placement="bottom"
                    delay={500}
                    className="custom-tooltip"
                  >
                    <div
                      className={`relative w-fit bg-transparent outline-none  rounded-md 
                    ${member.tracking?.isonline ? "" : "opacity-10"}
                    `}
                    >
                      <img
                        src={
                          member.photo
                            ? member.photo
                            : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRR2dtSs0-ybB7OnCnfsC1UWgViGQLxAtVx83IPHmxIjh1istqxGhm2sjWOSF1TDN_J-r0&usqp=CAU"
                        }
                        className={` w-7 h-7 rounded-md bg-white   ${member.tracking?.isonline ? " " : ""}`}
                      />
                    </div>
                  </Tippy>
                </div>
              ))}
          </div>
          <SupportAM orgData={orgData}></SupportAM>
          <SuperModal
            modal_name="support"
            isOpen={supportOpen}
            onClose={() => setSupportOpen(false)}
          ></SuperModal>
          <OnlineStatus userData={userData}></OnlineStatus>
        </div>
      </div>
    </div>
  );
}

export default HeaderBar;
